// auth strings (en). Source of truth for the auth surface.
const auth = {
	auth: {
		// Titles & headings
		signInTitle: 'Sign in to your account',
		signUpTitle: 'Create a new account',
		signUpToAccount: 'Sign up to your account',
		resetYourPassword: 'Reset your password',

		// Links & secondary actions
		or: 'Or',
		orLower: 'or',
		orDivider: 'OR',
		createNewAccount: 'Create a New Account',
		alreadyHaveAccountLogin: 'Already have an account? Log in',
		alreadyHaveAccount: 'Already have an account?',
		logIn: 'Log in',
		forgotPassword: 'Forgot password?',

		// Buttons
		signIn: 'Sign in',
		signUp: 'Sign up',
		signInWithGoogle: 'Sign in with Google',
		signUpWithGoogle: 'Sign up with Google',
		send: 'Send',

		// Field labels & placeholders
		emailAddress: 'Email address',
		yourEmailAddress: 'Your email address',
		emailPlaceholder: 'you@example.com',
		enterEmailAddress: 'Enter email address',
		password: 'Password',
		enterPassword: 'Enter password',
		rememberMe: 'Remember me',

		// Terms & consent
		agreeToOur: 'By signing up, you agree to our',
		termsOfService: 'terms of service',
		and: 'and',
		privacyPolicy: 'privacy policy',

		// Invitation
		invitedToJoin: 'You have been invited to join %{workspace} Workspace',

		// Testimonials panel
		clientsSayHeading: 'What Our Clients Say About Us',
		companiesTrust: 'More than 1000 companies are building better relationship using CardClan',

		// Alerts / dialog titles
		errorTitle: 'Error',
		successTitle: 'Success',
		oops: 'Oops!',

		// Alert / validation messages
		passwordResetLinkSent: 'A password reset link has been sent to your email.',
		emailNotRegistered: 'This email is not registered.',
		wrongPassword: 'Password you entered is incorrect.',
		unknownError: 'An unknown error has occurred. Please contact support at support@cardclan.io.',
		invalidEmail: 'Invalid email format',
		emailRequired: 'Email is required',
		passwordRequired: 'Password is required',
		passwordRules:
			'Password should be 6 to 18 characters long with at least 1 uppercase and 1 lowercase letter and at least 1 number.',
	} as Record<string, string>,
};
export default auth;
